import React, { Suspense } from 'react';
import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import LoadingScreen from '../../../common/LoadingScreen';

import { eventListingsURL } from '../constants';
import {
  EventListingsScreenContainer,
  ContactScreen,
} from '../screens';

const CreateScreen = React.lazy(() => import('../screens/CreateScreen'));
const PaymentScreen = React.lazy(() => import('../screens/PaymentScreen'));
const ConfirmationScreen = React.lazy(() => import('../screens/ConfirmationScreen'));

const ArticleLicensingRoutes = () => {
  const { stripePublicKey } = window.eventListings;
  const stripePromise = loadStripe(stripePublicKey);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route exact path={`${eventListingsURL}/`} element={<Navigate to="contact" replace />} />
        <Route path={`${eventListingsURL}`} element={<EventListingsScreenContainer />}>
          <Route path="contact" element={<ContactScreen />} />
        </Route>

        {/* Prefer parallel routes for Container components to maintain access to Outlet context */}
        {/* as of 6.3.0 useOutletContext only provides context to direct children: https://stackoverflow.com/a/71882311 */}
        <Route exact path={`${eventListingsURL}/:token`} element={<Navigate to="details" replace />} />
        <Route path={`${eventListingsURL}/:token`} element={<EventListingsScreenContainer />}>
          <Route path="contact" element={<ContactScreen />} />
          <Route path="details" element={<CreateScreen />} />
          <Route path="checkout" element={<Elements stripe={stripePromise}><PaymentScreen /></Elements>} />
          <Route path="confirmation" element={<ConfirmationScreen />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default ArticleLicensingRoutes;
